import { styled } from "@mui/system";
import { colors } from "../../../utils";
// import styled MuiStyled from "styled-components";

export const CardContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "100%",
  height: "250px",
  padding: "16px",
  boxSizing: "border-box",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  position: "relative",
  overflow: "hidden",
  justifyContent: "space-between",
});

export const TopSection = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ProfileImageWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 70,
  // marginTop: "0.7rem",
});

export const ProfileImage = styled("img")({
  width: "54px",
  height: "54px",
  borderRadius: "50%",
});

export const ProfileImageInnerWrapper = styled("div")({
  display: "flex",
});

export const TextWrapper = styled("div")({});
export const DescriptionWrapper = styled("div")({
  height: 40,
  width: 40,
  backgroundColor: colors.background,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  marginRight: 10,
});

export const ProfileInfo = styled("div")({
  paddingTop: 10,
});

export const IconWrapper = styled("div")({
  display: "flex",
  gap: 15,
  justifyContent: "center",
});

export const SocialLinksWrapper = styled("div")({
  display: "flex",
  gap: 10,
  margin: "10px 0px",
});

export const SocialLinkItem = styled("div")({
  width: 32,
  height: 32,
  cursor: "pointer",
});
export const Row = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
});
